import React, { useState } from "react";
import { Table } from "reactstrap";
import { formatDate } from "../../../../Utils/format-date.js";
import { addClassName } from "../../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../../Utils/calculate-progress.js";
import Button from "../../../../Utils/Button/index";
import LayoutCard from "../../../Layout/Layout";
import MyReportsIcon from "../../../../../images/new-images/myreports.png";
import OpPopover from "../../../PopOver/Popover";
import info_black_24dp from "../../../../../images/info_black_24dp.png";
import Renderpopoverinnercontent from "../../../../Dashboard/My-assessments/popover-inner-content";
import "./Assessment-Table.css";
import completed from "../../../../../images/new-images/completed.png";
import { Link } from "react-router-dom";
import { LoaderComp } from "../../../../../_components/common/LoaderComp/Loadercomp.js";

const completedReportsTable = (props) => {
  const isAuthParticipant = localStorage.getItem("is_auth_participant");


  return (
    <LayoutCard headerIcon={MyReportsIcon} headerText="My Reports">
       <div className="my-reports">
        {props.completedReports === undefined || props.completedReports.length === 0 ? (
          <div className="loader-container">
            <LoaderComp color={'black'} />
          </div>
        ) : props.completedReports.length === 0 ? (
          <h1 className="no-reports">There are no reports available</h1>
        ) : (
          <Table>
            <thead>
              <tr>
                <th className="tableHeaders">Assessment Type</th>
                <th className="tableHeaders">Date Of Expiry</th>
                <th className="tableHeaders">Status</th>
                <th className="tableHeaders">Action</th>
              </tr>
            </thead>
            <tbody>
              {props.completedReports.map((assessment, index) => {
                return (
                  <React.Fragment key={index}>
                    <tr key={index}>
                      <td>
                        <div className="assessmentType">
                          <img
                            className="assessmentIcon"
                            src={
                              localStorage.getItem("baseLink") +
                              `/media/` +
                              assessment.instrument__instrument_image
                            }
                            alt="Assessment Icon"
                          />
                          <div className="assessmentName">
                            {assessment.instrument__dashboard_header_text}
                          </div>
                          <OpPopover
                            positions={["right"]}
                            align={"center"}
                            targtElement={
                              <img className="infoIcon" src={info_black_24dp} alt="Info Icon" />
                            }
                            isOpen={
                              props.isPopOverOpenAssessmentId === assessment.id
                            }
                            setOpen={(bool) => {
                              props.handleAssessmentPopOver(
                                bool ? assessment.id : false
                              );
                            }}
                          >
                            <Renderpopoverinnercontent
                              handleClosePopOver={props.handleClosePopOver}
                              assessmentheading={
                                assessment.instrument__dashboard_header_text
                              }
                              assesmentdescription={
                                assessment.instrument__dashboard_header_description
                              }
                            />
                          </OpPopover>
                        </div>
                        <div className="userName">
                          {assessment.participant__full_name && `${assessment.participant__full_name}'s`}
                          <span style={{ marginLeft: '5px' }}>{assessment.instrument__instrument_name}</span>
                        </div>
                      </td>
                      <td>
                        <div className="Date">
                          {formatDate(assessment.expiry_date)}
                        </div>
                      </td>
                      <td>
                        {assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <div
                            style={{ display: "flex" }}
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                            {calcPercentage(
                              assessment.assessment_number_count,
                              assessment.assessment_completed_count
                            )}
                          </div>
                        ) : assessment.assessment_status__status_name ===
                          "Report in review" ? (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            Completed
                            <img src={completed} alt="Completed Image" />
                          </div>
                        ) : (
                          <div
                            className={
                              "assessment-status-text " +
                              addClassName(
                                assessment.assessment_status__status_name
                              )
                            }
                          >
                            {assessment.assessment_status__status_name}
                          </div>
                        )}
                      </td>
                      <td>
                        {(assessment.assessment_status__status_name ===
                          "Completed" ||
                          assessment.assessment_status__status_name ===
                          "Report in review") && isAuthParticipant === 'false' ? (
                          <Link
                            to={{
                              pathname: `/new/app/reportdownload/${assessment.id}/${assessment.participant__id}`,
                            }}
                          >
                            <Button type="submit">VIEW REPORT</Button>
                          </Link>
                        ) : assessment.assessment_status__status_name ===
                          "In progress" ? (
                          <Link to="/new/app/questionnaire">
                            <Button type="resume">Resume</Button>
                          </Link>
                        ) : (
                          <Button type="disabled report">VIEW REPORT</Button>
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    </LayoutCard>
  );
};

export default completedReportsTable;


// WEBPACK FOOTER //
// ./src/new/Components/Reports/My-Reports/Assessment-Table/Completed-reports-table.jsx